/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';

export const imageWrapper = css({
  img: {
    width: '100%',
  },
});
export const arrowBtnCss = css({
  border: 'none',
  padding: 0,
  width: 20,
  height: 20,
  backgroundColor: colorsPalette.transparent,
  '&:hover': {
    cursor: 'pointer',
  },
});

export const leftButtonCss = css({
  marginRight: 25,
  [MediaQueries.lg]: {
    marginRight: 15,
  },
});

export const arrowCss = css({
  position: 'relative',
  width: 20,
  height: 20,
  '&:before': {
    color: colorsPalette.grey,
    position: 'absolute',
    top: '50%',
    marginTop: -8,
    left: '50%',
    marginLeft: -8,
  },
});

export const arrowLeftCss = css({
  '&:before': {
    left: 0,
    marginLeft: 0,
  },
});

export const buttonsWrapperCss = css({
  display: 'inline-block',
  textAlign: 'right',
  paddingRight: 16,
  [MediaQueries.lg]: {
    paddingRight: 15,
  },
});

export const imageCaptionCss = css({
  color: colorsPalette.grey80,
});

export const captionControlsCss = css({
  justifyContent: 'space-between',
  [MediaQueries.md]: {
    marginTop: 9,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 18,
  },
});

export const activeImageCss = css({
  display: 'inline',
  flexDirection: 'column',
});

export const inactiveImageCss = css({
  display: 'none',
});
